export function contiguousGroupBy (list, predicate) {
  let fn_prev = null
  let acc = []
  for (let val of [].concat(list)) {
    let fn_curr = predicate(val)
    if (!acc.length || fn_curr !== fn_prev) {
      acc.push([val])
    } else {
      acc[acc.length - 1].push(val)
    }
    fn_prev = fn_curr
  }
  return acc
}
